/**
 * axios简单封装
 * 主要是方便调试及输出Log
 */
import md5 from "../common/md5";
const axios = require('axios').default

const fg = require('../common/fingerprint2.1.4')


const isProduction = Object.is(process.env.NODE_ENV, 'production') //是否生产环境
//测试环境的地址到config/index.js中的proxyTable修改
// var DOMIN = isProduction ? 'https://www.***/index.php/Official（线上地址）' : 'api/';
// var DOMIN = '//tsdk2.tianxie18.com/v2';
var DOMIN = '//sdk.tianxie18.com/v2';

axios.defaults.baseURL = DOMIN //解决跨域问题

var uuid = "";
var user_agent = "";
var isCheckIdfa = false; // 是否有检查过idfa
function generateUUID() {
  try {
    var rMap = {};
    fg.Fingerprint2.get(function (components) {
      const values = components.map(function (component, index) {
        rMap[component.key] = component.value;
        if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
          return component.value.replace(/\bNetType\/\w+\b/, '')
        }
        return component.value
      })
      // 生成最终id murmur
      delete rMap.canvas;
      delete rMap.webgl;
      delete rMap.plugins;
      // console.log("浏览器信息：" + JSON.stringify(rMap)) //使用的浏览器信息
      const murmur = fg.Fingerprint2.x64hash128(values.join(''), 31)
      // console.log(murmur) //生成的标识码
      uuid = murmur;
      user_agent = rMap.userAgent;
    })
  } catch (e) {
    console.log("生成浏览器唯一标识码错误" + e);
  }
}

generateUUID();
//测试写死数据
// project_id:133
// secret_key:b698412cd97e551e360c751ded90ad29
// ad_position_id:10024987
// package_id:24903
// mac:08:00:27:92:CE:6A
let deviceParams = {
  "ad_position_id": "",
  "package_id": "",
  "uuid": "",
  "mac": "",
  "ch_sdk_version": "",
  "network": "",
  "ext_params": "",
  "aaid": "",
  "system_version": "",
  "display_size": "",
  "model": "",
  "udid": "",
  "camera": "",
  "brand": "",
  "user_agent": "",
  "oaid": "",
  "gyro": "0",
  "is_emulator": "",
  "battery_power": "",
  "idfa": "",
  "build_level": "",
  "cpu": "",
  "vaid": "",
  "package_version": "",
  "screen_light": "",
  "blueteeth": "0",
  "imei": "",
  "tools_version": "",
  "tx_jssdk_version": "1.0.0",
  "event_time": Math.round(new Date() / 1000),
  "has_light_sensor": "1",
  "os": "iOS"
}


function get(url, params) {
  return request(url, params, "get");
}

function post(url, params) {
  return request(url, params, "post");
}

function upload(url, params) {
  return request(url, params, "upload");
}

const sleep = time => new Promise(resolve => setTimeout(() => resolve(), time))

async function request(url, params, method) {
  var extendParams = Object.assign({}, window.TXPARAMS)
  extendParams.tx_id = window.TXID
  extendParams.token = window.TXTOKEN
  if (method != 'upload') {
    for (var key in params) {
      extendParams[key] = params[key];
    }
  }
  if (uuid == "" || uuid == undefined) {
    // window.toast('初始化失败！3秒后再次进行初始化.');
    // !!!这里需要将登录页面隐藏后再进行重新生成UUID，否则生成的UUID会与之前不一致!!!
    setTimeout(() => {
      window.eventEmitter.emit("event_sdk_pop_win", { isShowPopWin: false });
      generateUUID();
      setTimeout(() => {
        window.eventEmitter.emit("event_sdk_pop_win", { isShowPopWin: true });
      }, 1500)
    }, 1500)
    await sleep(3000);
    // generateUUID();
    // console.log("uuid:" + uuid);
  }
  extendParams.event_time = new Date().getTime();
  //附加参数
  extendParams.os = "iOS";
  extendParams.itx_sdk_type = "jssdk";
  extendParams.js_uuid = uuid;
  extendParams.user_agent = user_agent;
  extendParams.sign = getSign(extendParams);
  // 基本参数
  let finalParams = Object.assign({}, deviceParams);
  for (let key in extendParams) {
    finalParams[key] = extendParams[key];
  }
  // url参数
  // url参数为undefined、idfa为空或者undefined,进行数据上报（isCheckIdfa:是否有检查过idfa）
  // if (!isCheckIdfa && (!window.itx_url_params || window.itx_url_params.idfa == "" || window.itx_url_params.idfa == undefined)) {
  //     isCheckIdfa = true;
  //     checkIdfa();
  // }
  // 参数若为undefined、unknown、null,将其置空
  for (let key in finalParams) {
    if (finalParams[key] == undefined || finalParams[key] == "unknown" || finalParams[key] == null) finalParams[key] = "";
  }
  if (finalParams.token == "") {
    delete finalParams.tx_id;
    delete finalParams.token;
  }
  if (finalParams.ad_position_id && finalParams.package_id) {
    if (method == 'upload') {
      for (var key in finalParams) {
        params.append(key, finalParams[key])
      }
      return uploadRequest(url, params)
    } else {
      return performRequest(method, url, finalParams)
    }
  } else {
    window.postMessage({ msg_type: 'itx_error', data: { msg: '游戏启动异常，请退出重进' } }, '*')
    return false
  }
}

function performRequest(method, url, params) {
  return new Promise(function (resolve, reject) {
    let httpPromise = Object.is(method, "get") ? axios.get(url, params) : axios.post(url, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    httpPromise
      .then(function (response) {
        // log(method + "=====> 请求地址：" + DOMIN + url +
        //   "\n=====> 请求参数：" + JSON.stringify(params) +
        //   "\n=====> tx-axios请求成功：" + JSON.stringify(response.data));
        if (response.data.code == 200) {
          resolve(response.data)
        } else {
          window.toast(response.data.msg)
          reject(response.data)
        }
      })
      .catch(function (err) {
        // log(method + "=====> 请求地址：" + DOMIN + url +
        //   "\n=====> 请求参数：" + JSON.stringify(params) +
        //   "\n=====> tx-axios请求失败：" + JSON.stringify(err.response));
        window.toast(err.response.data.msg)
        reject(err)
      });
  });
}
function uploadRequest(url, params) {
  return new Promise(function (resolve, reject) {
    axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(function (response) {
        // log("upload=====> 请求地址：" + DOMIN + url +
        //   "\n=====> tx-axios请求成功：" + JSON.stringify(response.data));
        if (response.data.code == 200) {
          resolve(response.data)
        } else {
          window.toast(response.data.msg)
          reject(response.data)
        }
      })
      .catch(function (err) {
        // log("upload=====> 请求地址：" + DOMIN + '/util/uploadImg' +
        //   "\n=====> tx-axios请求失败：" + JSON.stringify(err.response));
        window.toast(err.response.data.msg)
        reject(err)
      });
  });
}

//加签方法
function getSign(data) {
  // 1、排序
  data = objKeySort(data);
  // 2.拼接
  var txt = "";
  var keys = Object.keys(data);
  for (var i = 0; i < keys.length; i++) { // 遍历newkey数组
    var key = keys[i];
    var val = data[keys[i]];
    txt += key + "=" + val + "&"
  }
  // txt = txt.substring(0, txt.length - 1);
  txt += ''; //到时可能会加一个key，打包的时候打进去
  // log("待加签字符串：" + txt);
  txt = md5.md5(txt);
  // log("加签结果" + txt);
  return txt;
}

function objKeySort(obj) { // 排序的函数
  var newkey = Object.keys(obj).sort(sortCharter);
  // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {}; // 创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) { // 遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]]; // 向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj; // 返回排好序的新对象
}

// 字母排序：不区分大小写
function sortCharter(a, b) {
  if (a.toString().toLowerCase() > b.toString().toLowerCase()) {
    return 1;
  } else if (a.toString().toLowerCase() == b.toString().toLowerCase()) {
    return 0;
  } else {
    return -1;
  }
}

var debug_log = true;

function log(string) {
  if (debug_log) {
    console.log(string);
  }
}

export default {
  get,
  post,
  upload,
  DOMIN
}

/**
 * @deprecated 由于广告位、包id均为空，无法进行上报请求 故废弃该方法
 */
// 检测idfa参数是否为空,是的话上报日志
function checkIdfa() {
  let params = window.getUrlkey(window.location.href);
  window.itx_url_params = params; // 将解析的url参数重新赋值
  // console.log("url params: " + JSON.stringify(params));
  if (params.idfa == "") {
    //上报给服务端
    let content = "idfa is empty.\n";
    content += "url:" + window.location.href;
    action.requestLog({
      log_type: "EXCEPTION",
      content: content,
    })
  }
}

//检测字体大小 不正常时iframe会显示异常 表现为看不到页面
var count = 0;
window.onload = updatedFontSize();

function updatedFontSize() {
  if (count == 5) return;

  var fontSize = Math.max(Math.max(document.body.scrollWidth, document.documentElement.clientWidth), document.body.offsetWidth) / 10;
  if (fontSize == 0) {
    // console.log("大小为0,不进行赋值,准备递归..." + ++count);
    setTimeout(updatedFontSize, 300);
  } else {
    document.documentElement.style.fontSize = fontSize + 'px';
  }
}

// 全局异常捕获
window.onerror = handleError

function handleError(msg, url, l) {
  // 脚本错误异常不再上报
  if (msg == 'Script error.') return;


  var txt = "There was an error on this page.\n"
  txt += "Error: " + msg + "\n"
  txt += "URL: " + url + "\n"
  txt += "Line: " + l + "\n"

  window.action.requestLog({
    log_type: "error",
    content: txt,
  });
}



// WEBPACK FOOTER //
// ./src/http/tx-axios.js